// @systeme: interface
// Le journal d'audit : tout ce que l'admin a fait, ineffaçable, y compris ses lectures.
import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { EntreeAudit } from '@foyer/shared';
import { Chargement } from '../../composants/Chargement';
import { useMessages } from '../../composants/Messages';
import { api } from '../../lib/api';
import { formaterHeure, formaterJourCourt, jourDe } from '../../lib/dates';

export function Journal() {
  const { direErreur } = useMessages();
  const [entrees, setEntrees] = useState<EntreeAudit[] | undefined>();

  useEffect(() => {
    api.admin.journal().then(setEntrees).catch(direErreur);
  }, [direErreur]);

  if (!entrees) return <Chargement />;
  return (
    <Stack spacing={0.75}>
      <Typography color="text.secondary" sx={{ mb: 1 }}>
        Les trois cents dernières entrées. Ce journal ne s’efface pas, même par toi.
      </Typography>
      {entrees.map((e) => (
        <Typography key={e.id} variant="body2">
          <Typography component="span" variant="body2" color="text.secondary">
            {formaterJourCourt(jourDe(e.creeLe))} {formaterHeure(e.creeLe)} ·{' '}
          </Typography>
          {e.action}
          {e.details !== null && e.details !== undefined && (
            <Typography component="span" variant="body2" color="text.secondary">
              {' '}
              {JSON.stringify(e.details)}
            </Typography>
          )}
        </Typography>
      ))}
    </Stack>
  );
}
